export enum MUTATION_KEYS {
  CREATE_CAD_VERSION = 'CREATE_CAD_VERSION',
  UPDATE_CAD_VERSION = 'UPDATE_CAD_VERSION',
  UPDATE_CAD_VERSION_UPLOADED = 'UPDATE_CAD_VERSION_UPLOADED',
}

export default MUTATION_KEYS
